// extracted by mini-css-extract-plugin
export var cardIcon = "_8i-5";
export var cardIconUnframed = "_8i-9";
export var checkboxCard = "_8i-0";
export var checkboxCardSelected = "_8i-4";
export var disabled = "_8i-2";
export var interactive = "_8i-1";
export var outerBorder = "_8i-3";
export var spacerMedium = "_8i-8";
export var spacerSmall = "_8i-7";
export var spacerXsmall = "_8i-6";